import { Text } from "@solomon-labs/design/components/ui";
import React from "react";

import { DistributionRewardsAnimation } from "./DistributionRewardsAnimation";

/**
 * Distribution history, before the first distribution.
 *
 * Held USDv stays in place while illustrative payouts travel to holders.
 * The animation carries no live balances or completed-distribution claims.
 *
 * Rendered INSTEAD of the table, not inside its empty row. Two reasons:
 * the table's horizontal scroller carries a `min-w-[720px]` floor that
 * four timestamp and signature columns need and a sentence does not, so
 * an empty state inside it forces a scrollbar on a phone for no content;
 * and column headers over nothing describe a table that is not there.
 */
export function DistributionHistoryEmpty(): React.ReactElement {
    return (
        <div className="flex flex-col items-center px-4 py-10 text-center">
            <DistributionRewardsAnimation />
            <Text variant="h3" render={<h3 />} className="text-foreground-base">
                No Rewards Distributed Yet
            </Text>
            <Text
                variant="small"
                render={<p />}
                className="text-foreground-neutral mt-2 max-w-sm text-balance"
            >
                Rewards continue to accrue. You’ll receive them in periodic
                distributions.
            </Text>
        </div>
    );
}
